export default class ImageHelpers {
    static SetHoverEffectOnImage(scene: Phaser.Scene, image: Phaser.GameObjects.Image) {
        image.setInteractive();

        const baseScaleX = image.scaleX;
        const baseScaleY = image.scaleY;

        image.on('pointerover', () => {
            scene.tweens.add({
                targets: image,
                scaleX: baseScaleX * 1.2,
                scaleY: baseScaleY * 1.2,
                duration: 100,
                ease: 'Power1'
            });
        });

        image.on('pointerout', () => {
            scene.tweens.add({
                targets: image,
                scaleX: baseScaleX,
                scaleY: baseScaleY,
                duration: 100,
                ease: 'Power1'
            });
        });
    }
}

